export default "__VITE_ASSET__CJ7U2u5F__"